import { Box, styled } from '@mui/material'

export const FooterContainer = styled(Box)(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	padding: '32px 40px',
	color: '#ffffff',
	backgroundColor: theme.palette.primary.main,
	[theme.breakpoints.down('md')]: {
		display: 'none'
	}
}))

export const TopSection = styled(Box)({
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'flex-start',
	paddingBottom: '20px'
})

export const RightSection = styled(Box)({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'flex-end'
})

export const NavItems = styled(Box)({
	display: 'flex',
	alignItems: 'center',
	gap: '35px',
	'& a': {
		color: '#ffffff',
		textDecoration: 'none',
		fontWeight: '325 !important',
		'& :hover': {
			textDecoration: 'underline'
		}
	}
})

export const SocialMediaIcons = styled(Box)({
	display: 'flex',
	alignItems: 'center',
	gap: '15px',
	marginTop: '24px',
	'& a': {
		color: '#ffffff',
		textDecoration: 'none'
	}
})

export const LowerFooter = styled(Box)({
	textAlign: 'left',
	paddingTop: '20px'
})
